

import { Component, Vue, Watch } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

import "vue-cal/dist/vuecal.css"
import { Route } from "vue-router"
import { getStylesheetName } from "./utils/ThemeLoader"

import "quill/dist/quill.core.css" // import styles
import "quill/dist/quill.snow.css" // for snow theme

@Component({
	components: {}
})
export default class App extends Vue {
	@Mutation public setScreenWidth!: (width: number) => void;
	@Mutation public setDarkMode!: (darkMode: boolean) => void;

	@State public darkMode!: boolean
	@Action public applyTheme!: (darkMode: boolean) => void;

	@Getter("getScreenWidth") public screenWidth!: number;

	@Action public startUp!: () => void;

	private themeColours!: string;

	public async created () {
		const link = document.createElement("link")
		link.id = "lightdark"
		link.rel = "stylesheet"

		const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches

		// This ensures it is default to false, will get set to correct value when a user logs in later
		const isNewInterface = false
		link.href = getStylesheetName(isDarkMode, isNewInterface)

		this.themeColours = isDarkMode ? "dark" : "light"

		document.head.appendChild(link)

		console.log("Theme", isDarkMode)
		this.setDarkMode(isDarkMode)

		if (this.$route.meta.forceTheme !== undefined) {
			// Force theme for theme-specific routes
			this.applyTheme(this.$route.meta.forceTheme)
		}
	}

	@Watch("$route")
	onRouteChanged (to: Route, from: Route) {
		if (to.meta.forceTheme !== undefined) {
			console.log("Forcing theme", this.$route.meta.forceTheme)
			this.applyTheme(this.$route.meta.forceTheme)
		} else if (from && from.meta && from.meta.forceTheme !== undefined) {
			console.log("Restoring theme", this.darkMode)
			this.applyTheme(this.darkMode)
		}
	}

	public async mounted () {
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				this.setScreenWidth(screen.width)
			})
			this.setScreenWidth(screen.width)
		})

		this.startUp()
	}
}
